import React, { useState } from 'react';
import { toast } from 'react-toastify';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';

// import JS files
import MuiPagination from '../../../shares/MuiPagination';
import PanelFilter from '../../../shares/PanelFilter';
import PanelTable from '../../../shares/PanelTable';
import PanelTemplate from '../../../shares/PanelTemplate';
import OrderDetails from './OrderDetails';
import RemoveOrder from './RemoveOrder';
import useFetch from '../../../../context/useFetch';
import ChangeCustomer from './ChangeCustomer';
import { fixNumbers } from '../../../../utils';
import MuiButton from '../../../shares/MuiButton';
import PrintIcon from '@mui/icons-material/Print';
import { useNavigate } from 'react-router-dom';
import AdminPrintNewOrderiInfo from './AdminPrintNewOrderiInfo';

const headersList = [
  { colName: 'name', name: 'مشتری' },
  { colName: 'unique_id', name: ' سند' },
  { colName: 'created_at', name: 'تاریخ ثبت سفارش' },
  { colName: 'total', name: 'وزن' },
  { colName: 'details', name: 'جزییات سفارش' },
  { colName: 'change_customer', name: 'تغییر مشتری' },
  { colName: 'print', name: 'چاپ سفارش' },
  // { colName: 'remove', name: 'لغو سفارش' },
];
const dataKey = ['name', 'unique_id', 'created_at', 'total'];

const mobileHeadersList = [
  { colName: 'name', name: 'مشتری' },
  { colName: 'unique_id', name: ' سند' },
  { colName: 'created_at', name: 'تاریخ ثبت سفارش' },
  { colName: 'total', name: 'وزن' },
];

const CustomerNewOrders = (props) => {
  const navigate = useNavigate();
  const [newOerdersList, setNewOerdersList] = useState({ results: [] });
  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [storeFilter, setStoreFilter] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);

  const filterList = [
    {
      type: 'textField',
      label_fa: 'سند',
      label_en: 'code',
      state: codeFilter,
    },
    {
      type: 'textField',
      label_fa: 'نام مشتری',
      label_en: 'storeName',
      state: storeFilter,
    },
    {
      type: 'datePicker',
      label_fa: 'تاریخ ثبت سفارش',
      label_en: 'date',
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const adminGetCustomerCreateOrderApi = useFetch({
    method: 'get',
    url: `Order_Service/admin_get_create_order`,
    params: {
      unique_id: fixNumbers(codeFilter),
      store_name: storeFilter,
      date: dateFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setNewOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error('خطایی رخ داده است', {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == 'code') setCodeFilter(e.length > 0 ? e : null);
    if (state == 'date') setDateFilter(e.length > 0 ? e : null);
    if (state == 'storeName') setStoreFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (codeFilter !== null || dateFilter !== null || storeFilter !== null) {
      setIsFilterOn(true);
      setNewOerdersList({ results: [] });

      adminGetCustomerCreateOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);
    adminGetCustomerCreateOrderApi.reFetch();
  };

  const buttonsList = [
    {
      label: 'جزییات سفارش',
      component: (it) => (
        <OrderDetails
          setNewOerdersList={setNewOerdersList}
          selectedRow={it}
          adminGetCustomerCreateOrderApi={adminGetCustomerCreateOrderApi}
        />
      ),
    },
    {
      label: 'تغییر مشتری',
      component: (it) => (
        <ChangeCustomer
          selectedRow={it}
          adminGetCustomerCreateOrderApi={adminGetCustomerCreateOrderApi}
        />
      ),
    },
  ];
  const actionsList = [
    {
      label: 'چاپ',
      component: (it) => (
        <AdminPrintNewOrderiInfo inCurrentOrder selectedRow={it} />
      ),
    },
    // {
    //   label: 'لغو سفارش',
    //   component: (it) => (
    //     <RemoveOrder
    //       selectedRow={it}
    //       adminGetCustomerCreateOrderApi={adminGetCustomerCreateOrderApi}
    //     />
    //   ),
    // },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setNewOerdersList({ results: [] });

    adminGetCustomerCreateOrderApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-new-orders/${codeFilter}/${storeFilter}/${dateFilter}`
    // );
    window.open(
      `/print-customers-new-orders/${codeFilter}/${storeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="c-new-orders">
        <>
          <div className="panel-main-header">
            <span>سفارش‌های جدید</span>
          </div>
          <PanelFilter
            header="فیلتر سفارش‌ها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <div className="flex justify-end">
            <MuiButton
              onClick={handelPrintReport}
              variant="outlined"
              icon={<PrintIcon />}
              color="primary"
              text="چاپ گزارش"
              margin="mr-2"
            />
          </div>
          <>
            <PanelTable
              header="لیست سفارش‌های جدید:"
              headers={headersList}
              mobileHeaders={mobileHeadersList}
              data={newOerdersList.results}
              dataKey={dataKey}
              buttons={buttonsList}
              actions={actionsList}
              icon={<AccountBalanceIcon />}
            />
            <MuiPagination
              onChange={onChangePage}
              count={Math.ceil(
                paginationPageInfo.count / paginationPageInfo.pageSize
              )}
            />
          </>
        </>
      </PanelTemplate>
    </>
  );
};

export default CustomerNewOrders;
